const posts = [
  {
    title: 'JavaScript Prototypes for Data Structures',
    date: new Date(),
    body: 'blah blahblah blahblah blah blah blah blah blah blah blah blah blahblah blahblah' +
        ' blah blah blah blah blah blah blah blah blahblah blah blah blah blah blah blah ' +
        'blahblah blah blah blah blah blah blah blahblah blah blah blah blah blahblah bla' +
        'hblah blahblah blahblah blahblah blah blah blahblah blahblah blahblah blahblah b' +
        'lahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah ' +
        'blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah' +
        ' blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahbla' +
        'h blahblah blahblah blahblah blah'
  }, {
    title: 'Dockerize Your Node',
    date: new Date(),
    body: 'blah blahblah blahblah blah blah blah blah blah blah blah blah blahblah blahblah' +
        ' blah blah blah blah blah blah blah blah blahblah blah blah blah blah blah blah ' +
        'blahblah blah blah blah blah blah blah blahblah blah blah blah blah blahblah bla' +
        'hblah blahblah blahblah blahblah blah blah blahblah blahblah blahblah blahblah b' +
        'lahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah ' +
        'blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah' +
        ' blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahbla' +
        'h blahblah blahblah blahblah blah'
  }, {
    title: 'Fake Blag Post',
    date: new Date(),
    body: 'blah blahblah blahblah blah blah blah blah blah blah blah blah blahblah blahblah' +
        ' blah blah blah blah blah blah blah blah blahblah blah blah blah blah blah blah ' +
        'blahblah blah blah blah blah blah blah blahblah blah blah blah blah blahblah bla' +
        'hblah blahblah blahblah blahblah blah blah blahblah blahblah blahblah blahblah b' +
        'lahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah ' +
        'blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah' +
        ' blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahblah blahbla' +
        'h blahblah blahblah blahblah blah'
  }
];

export default posts;



// WEBPACK FOOTER //
// ./src/data/blog.js